module.exports = __webpack_public_path__ + "static/media/stat_design.e0562b32.png";